import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class FirQbuSourcingDeleteRecordService {

  constructor(private http: HttpClient) { }

  deleteQbuSourcingRecord(
    baseUrl: string,
    jsonData: any, // tempData object with TAX_YEAR, SCENARIO, JCD_KEY, SSO_ID, DEL_PARAMS
    baseGlobalParams: any,
    checkLockedObj: any,
    filterParams: any = {},
    gridData: any = {}
  ): Observable<any> {
    
    const url = `${baseUrl}/saveJsonObject?action_code=ffohdt`;

    let params = _.merge({}, baseGlobalParams || {}, filterParams);
    
    params = _.extend({
      "tax_year": jsonData.TAX_YEAR.toString(),
      "scenario": jsonData.SCENARIO.toString(),
      "jcd_key": jsonData.JCD_KEY.toString(),
      "sso_id": jsonData.SSO_ID,
      "is_issue_key_enabled": baseGlobalParams?.is_issue_key_enabled || 'N',
      "clob_data": jsonData.DEL_PARAMS,
      "scenarioCode": baseGlobalParams?.scenarioCode || '',
      "checkLockedbj": JSON.stringify(checkLockedObj)
    }, params);

    if (filterParams.filing_key) {
      params.filing_key = filterParams.filing_key;
    }

    const formData = new FormData();
    Object.keys(params).forEach((key) => {
      formData.append(key, params[key]);
    });

    const options = {
      withCredentials: true
    };

    return this.http.post<any>(url, formData, options);
  }
} 